<script>
import { emojis } from "@/js/emojiList";
import { Emoji } from "emoji-mart-vue";

export default {
  components: {
    Emoji
  },
  computed: {
    blinkText() {
      return Laravel.settings.blinkText;
    }
  },
  render(createElement) {
    let message = [];
    if (this.blinkText) {
      message = this.blinkText.split(":");
      message = message.map(part => {
        return emojis.includes(part)
          ? createElement("emoji", { attrs: { emoji: `:${part}:` } })
          : part;
      });
      message = message.map((part, index) => {
        return index > 0 &&
          typeof part == "string" &&
          typeof message[index - 1] == "string"
          ? ":" + part
          : part;
      });
    } else {
      message = "";
    }
    return createElement("span", [message]);
  }
};
</script>
